<template>
  <div class="page-wrap" :style="{ backgroundImage : 'url(' + activeObj.pageBgc + ')'}">
    <ul class="nineJiuge-table">
      <li v-for="(item, index) in activeObj.prizeData" :key="index" :class="['award' + index, { active: index == activeNum }]" class="award">
        <img src="/images/nineJiuge-item-bg.png" alt />
        <div class="mask" v-if="index == activeNum"></div>
      </li>
      <div class="nineJiuge-start-btn" @click="start">
        <h6>开始抽奖</h6>
      </div>
    </ul>
  </div>
</template>

<script>
export default {
  name: "nineJiuge",
  data() {
    return {
      activeObj: {
        pageBgc: "/images/nineJiuge-page-bg.png",
        prizeData: [
          // 图片名字与ID
          { id: 1, name: 10 },
          { id: 2, name: 100 },
          { id: 3, name: 2 },
          { id: 4, name: 1 },
          { id: 5, name: 5 },
          { id: 6, name: 50 },
          { id: 7, name: 0 },
          { id: 8, name: 5 },
        ],
      },
      tempArr: [0, 1, 2, 4, 7, 6, 5, 3], 
      activeNum: 0,
      current: 0, // 当前索引值
      speed: 200, // 时间->速度
      diff: 15, // 基数
      award: {}, // 抽中的奖品
      time: 0, // 当前时间戳
      timer: null, // 定时器
    };
  },
  methods: {
    //开始抽奖
    start() {
      this.getLottery();
      this.time = Date.now();
      this.speed = 200;
      this.diff = 10;
    },
    //调接口获取奖品
    getLottery() {
      this.award.name = "6";
      this.award.id = 6;
      this.move();
    },
    // 开始转动
    move() {
      this.timer = setTimeout(() => {
        this.current++;
        if (this.current > 7) {
          this.current = 0;
        }
        this.activeNum = this.tempArr[this.current];
        // 若抽中的奖品id存在，则开始减速转动
        if (this.award.id && (Date.now() - this.time) / 1000 > 2) {
          this.speed += this.diff; // 转动减速
          // 若转动时间超过4秒，并且奖品id等于小格子的奖品id，则停下来
          if (
            (Date.now() - this.time) / 1000 > 4 &&
            this.award.id == this.activeObj.prizeData[this.current].id
          ) {
            clearTimeout(this.timer);
            setTimeout(() => {
              this.$toast(`恭喜中奖${this.award.name}元`);
            }, 0);
            return;
          }
        } else {
          // 若抽中的奖品不存在，则加速转动
          this.speed -= this.diff;
        }
        this.move();
      }, this.speed);
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrap {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-top: 364px;
  padding-left: 63px;
  background-size: 100% auto;
  .nineJiuge-table {
    width: 246px;
    height: 198px;
    position: relative;
    .award {
      width: 80px;
      height: 64px;
      text-align: center;
      position: absolute;
      overflow: hidden;
      img {
        width: 80px;
        height: 64px;
      }
      &.active {
        .mask {
          position: absolute;
          top: 0;
          left: 0;
          width: 80px;
          height: 64px;
          border-radius: 10px;
          background-color: #fff0bd;
          opacity: 0.6;
          z-index: 8;
        }
      }
      &.award0 {
        top: 0;
        left: 0;
      }
      &.award1 {
        top: 0;
        left: 83px;
      }
      &.award2 {
        top: 0;
        right: 0;
      }
      &.award3 {
        top: 67px;
        left: 0;
      }
      &.award4 {
        top: 67px;
        right: 0;
      }
      &.award5 {
        bottom: 0;
        left: 0;
      }
      &.award6 {
        bottom: 0;
        left: 83px;
      }
      &.award7 {
        bottom: 0;
        right: 0;
      }
    }
    .nineJiuge-start-btn {
      position: absolute;
      width: 80px;
      height: 64px;
      top: 67px;
      left: 83px;
      border-radius: 10px;
      text-align: center;
      background: #ffd240;
      color: #ffffff;
      h6 {
        padding-top: 18px;
        font-size: 17px;
        line-height: 20px;
        font-weight: bold;
      }
    }
  }
}
</style>